module.exports = __webpack_public_path__ + "static/media/discount_sign.bf1703dd.png";